export const JOB_DETAIL_POLL_ACTIVE_MS = 4000;
export const JOB_DETAIL_POLL_HIDDEN_MS = 45000;

export function jobDetailPollIntervalMs(active: boolean, visible: boolean): number {
  if (!active) return 0;
  if (!visible) return JOB_DETAIL_POLL_HIDDEN_MS;
  return JOB_DETAIL_POLL_ACTIVE_MS;
}
